module.exports = __webpack_public_path__ + "static/media/testflightIcon.0d3d5388.png";